// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"97d00a74","247":"f34dcf47","395":"edcac904","535":"e31d9c90","577":"031a97d2","614":"f12c4dd8","656":"ad6f0559","787":"132d0665"}[chunkId] + ".chunk.js";
};